import { FormState } from '@vtex/admin-ui-form'
import { useAffiliates } from 'hooks'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { MultiSelect } from '../../MultiSelect'
import { searchItems } from '../../utils'
import { Item } from 'typings'

interface AffiliatesSelectorProps {
  name: string
  state?: FormState
  loading?: boolean
  placeholder?: string
}

const messages = {
  placeholder: {
    id: 'admin/promotions.form.conditions.affiliates.editor.selector',
  },
}

const MAX_OPTIONS = 10

export function AffiliatesSelector(props: AffiliatesSelectorProps) {
  const { name, state, placeholder, loading } = props

  const { data, isLoading } = useAffiliates()
  const { $t } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const options = useMemo<Item[]>(
    () => (data ? searchItems(data, searchTerm).slice(0, MAX_OPTIONS) : []),
    [data, searchTerm]
  )

  return (
    <MultiSelect
      name={name}
      options={options}
      label={placeholder ?? $t(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      state={state}
      maxEntries={LIMITS.MAX_AFFILIATES}
    />
  )
}
